import classnames from "classnames";
import * as React from "react";

import { Color } from "../../../consts";
import TextLink from "../../TextLink";
import "./IconLink.scss";

type Props = {
  to?: string;
  isExternal?: boolean;
  onClick?: () => void;
  text?: string;
  color?: Color | string | null | undefined;
  className?: string;
  iconClassName: string;
  iconRight?: boolean;
  underlineOnHover?: boolean;
  linkClassName?: string;
};

class IconLink extends React.PureComponent<Props> {
  static defaultProps = {
    underlineOnHover: true
  };

  render() {
    const {
      to,
      text,
      className,
      iconClassName,
      onClick,
      color,
      isExternal,
      iconRight,
      underlineOnHover,
      linkClassName
    } = this.props;
    return (
      <TextLink
        // @ts-ignore
        to={to}
        linkClassName={linkClassName}
        color={color}
        underlineOnHover={underlineOnHover}
        isExternal={isExternal}
        onClick={onClick}
        className={className}
      >
        <span className="IconLink">
          {!iconRight && <i className={iconClassName} />}
          {text}
          {iconRight && (
            <i className={classnames(iconClassName, "IconRight")} />
          )}
        </span>
      </TextLink>
    );
  }
}

export default IconLink;
